/**
 * Step 1: Add a flag here
 */
export const flags = {
  FeedPlusButton: 'FeedPlusButton',
  FeedPlusButtonMutation: 'FeedPlusButtonMutation',
  MonitorGraphQLResponses: 'MonitorGraphQLResponses',
  MonitorAnalyticsRequests: 'MonitorAnalyticsRequests',
  AnalyticsEventLogger: 'AnalyticsEventLogger',
  ForceOnboarding: 'ForceOnboarding',
  FeatureFlagsFromServer: 'FeatureFlagsFromServer',
  SubscriptionsEnabled: 'SubscriptionsEnabled',
  PollingEnabled: 'PollingEnabled',
};

/**
 * Step 2: Create a new entry for it and configure
 */
export const allFlags: any = [
  {
    section: 'Development',
    flags: [
      // {
      //   key: flags.FeedPlusButton,
      //   name: 'Feed: Plus button',
      //   description: 'When disabled, plus button is not visible to the user anywhere.',
      //   defaultValue: true,
      // },
      {
        key: flags.ForceOnboarding,
        name: 'Force Onboarding',
        description: 'Always send the user to onboarding. Logout/Login needed after enabling it.',
        defaultValue: false,
      },
      {
        key: flags.FeatureFlagsFromServer,
        name: 'Server Feature Flags',
        description:
          "Turn this switch off to manually change the feature flag status from localStorage without it being overwritten by the value from the server. With this switch off, to turn on groups: add 'ff-groups' as a key (with any value) in localStorage. Similarly to turn off groups, delete the key. Changes should be picked up by context automatically after a hard reload ",
        defaultValue: true,
      },
      {
        key: flags.FeedPlusButtonMutation,
        name: 'Feed: Plus button mutation',
        description:
          'When disabled, sharing is client-side only. Enable for sharing to trigger a mutation. (While not needed anymore after the refactor, this mechanism serves as the foundation for a future undo feature)',
        defaultValue: true,
      },
    ],
  },
  {
    section: 'Monitoring',
    flags: [
      {
        key: flags.MonitorGraphQLResponses,
        name: 'Queries',
        description: 'Logged in console',
        defaultValue: false,
      },
      {
        key: flags.AnalyticsEventLogger,
        name: 'Analytics events',
        description:
          'Logged in console, for events sent to 3rd party analytics services (eg amplitude, google analytics)',
        defaultValue: false,
      },
      {
        key: flags.MonitorAnalyticsRequests,
        name: 'Analytics requests',
        description:
          'Monitor supplementary requests made to the gql server by the analytics service',
        defaultValue: false,
      },
    ],
  },
  {
    section: 'Real time',
    flags: [
      {
        key: flags.SubscriptionsEnabled,
        name: 'Subscriptions ',
        description: 'Will pass through the websocket',
        defaultValue: false,
      },
      {
        key: flags.PollingEnabled,
        name: 'Polling',
        description: 'Home activity feed will poll for fresh data at 5 minute intervals',
        defaultValue: true,
      },
    ],
  },
];
